import has from 'lodash/has'
import { Doughnut } from 'vue-chartjs'
import CharConfig from './chartConfig'

export default Doughnut.extend({
  name: 'doughnut-chart',
  props: {
    data: {
      type: Object,
      required: true,
    },
  },
  mounted() {
    const Options = new CharConfig()

    if (has(this.data, 'title')) {
      Options.showTitle(this.data.title)
    }

    Options.showLegend()

    this.renderChart(this.data, Options)
  },
})



// WEBPACK FOOTER //
// ./components/chart/DoughnutChart.js